export const globalStyles = {
  body: {
    margin: 0,
    fontFamily: '"Lato", sans-serif'
  }
}
